<template>
    <div v-if="availabilityDate">
        <div class="availability-date__txt">{{ availabilityDate }}</div>
    </div>
</template>

<script>
    export default {
        inject: {
            itemId: {
                default: null
            }
        },

        computed: {
            currentItemVariation()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },

            availabilityDate()
            {
                if (this.currentItemVariation.variation.releasedAt !== ""){
                    const date = new Date(this.currentItemVariation.variation.releasedAt);

                    let dd = date.getDate();
                    let mm = date.getMonth() + 1;
                    let yyyy = date.getFullYear();

                    if (dd < 10)
                    {
                        dd = '0' + dd;
                    }

                    if (mm < 10)
                    {
                        mm = '0' + mm;
                    }

                    const dateString = dd + '.' + mm + '.' + yyyy;

                    let now = new Date();

                    if(now < date){
                        return this.$translate("ODFunsporthandel::Template.availabilityDate", { "date": dateString })
                    }

                    else{
                        return ""
                    }
                }

                else{
                    return ""
                }

            }
        }
    }
</script>
